import React from 'react';
import { useTranslation } from 'react-i18next';
import { useClient } from '@context/presentation';
import { STATIC_IMAGES, UNAVAILABLE_CS_FIRM } from '@constants';
import { CreditScoreStyle } from './styles';
import { generateSlideImageUrl } from '@utils/generateAssetLinks';

export const CreditScore = () => {
    const { t } = useTranslation();
    const { firmShortName } = useClient();
    const { creditScoreChart } = STATIC_IMAGES;
    const lawFirmUnavailable = firmShortName === UNAVAILABLE_CS_FIRM;

    return (
        <CreditScoreStyle>
            <img
                alt='credit-score-chart'
                src={generateSlideImageUrl(creditScoreChart)} />
            <div style={{ marginTop: '15px' }}>
                {
                    lawFirmUnavailable ? <>{t('credit_score.section-1.no-law-firm')}</> : 
                    <>
                        {t('credit_score.section-1.part-1')}
                        {firmShortName}
                        {t('credit_score.section-1.part-2')}
                        {firmShortName}
                        {t('credit_score.section-1.part-3')}
                    </>
                }
            </div>
            <div>{t('credit_score.section-2')}</div>
        </CreditScoreStyle>
    );
};

export default CreditScore;

